/**
 * Determine if Show form has edited its integration data
 *
 * @param data
 * @returns {boolean}
 */
export const hasNewIntegrationData = (data) => {
    if (data.new_store_type) {
        return true;
    }
    let integrations = data.integrations ?? [];
    if (integrations && integrations.length > 0) {
        // Compare against first integration; a Show only has one integration in practice
        const existing = integrations[0].store_metadata;
        if (
            (data.store_bill_ref_id_select && data.store_bill_ref_id_select !== existing.billing_reference_id) ||
            (existing.email_addresses ?? []).map(e => e.trim()).join(',') !== (data.store_email_addresses_str ?? '').split(',').map(e => e.trim()).join(',') ||
            existing.store_app_client_id !== data.store_app_client_id ||
            data.store_app_secret ||
            existing.store_url !== data.store_url
        ) {
            return true;
        }
    }
    return false;
};